import { useEffect, useState,useRef } from "react";
import axios from "axios";
import Portabilty_District from "./Portabilty_District";

function Portability() {
  const [month, setMonth] = useState([]);
  const [year, setYear] = useState([]);
  const date = new Date();
  const currentYear = date.getFullYear();
  const currentMonth = date.getMonth() + 1;
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [renderContent, setRenderContent] = useState(null);
  const nextTableRef = useRef(null);
  const currentTableRef = useRef(null);
  
  const handleSubmit = () => {
    if (currentTableRef.current) {
      const { bottom } = currentTableRef.current.getBoundingClientRect();
      window.scrollTo({
        top: window.scrollY + bottom + 10, 
        behavior: "smooth",
      });
    }

    
    setRenderContent(
      <div ref={nextTableRef}>
      <Portabilty_District selectedMonth={selectedMonth} selectedYear={selectedYear}
      onDataLoaded={() => {
        setTimeout(() => {
          if (nextTableRef.current) {
            const top = nextTableRef.current.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
              top: top + 10,
              behavior: "smooth"
            });
          }
        },0);
      }}
      />
      </div>
    );
    
  };
  

useEffect(() => {
  axios.get(`${process.env.REACT_APP_URL_HEADER}/Common/putMonths`)
    .then(response => {
      // Extract numbers from <option value='X'>
      const parser = new DOMParser();
      const doc = parser.parseFromString(response.data, "text/html");
      const options = Array.from(doc.querySelectorAll("option"));
      const monthValues = options.map(opt => Number(opt.value));
      setMonth(monthValues);
    })
    .catch(error => console.error("Error fetching months:", error));

  axios.get(`${process.env.REACT_APP_URL_HEADER}/Common/putYears`)
    .then(response => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(response.data, "text/html");
      const options = Array.from(doc.querySelectorAll("option"));
      const yearValues = options.map(opt => Number(opt.value));
      setYear(yearValues);
    })
    .catch(error => console.error("Error fetching years:", error));
}, []);


  

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const getMonthName = (month) => months[month - 1];

  return (
    <div className="wrapper row3" >
      
      <table align="center" border={1} ref={currentTableRef} width="40%">
        <thead>
          <tr className="tableheader"><th colSpan={4}>Portability Abstract</th></tr>
        </thead>
        <tbody>
          <tr>
            <td><label>Month:</label></td>
            <td>
              <select value={selectedMonth} onChange={(e) => setSelectedMonth(Number(e.target.value))}>
                {month.map((m, index) => (
                  <option key={index} value={m}>{getMonthName(m)}</option>
                ))}
              </select>
            </td> 
            <td><label>Year:</label></td>
            <td>
              <select value={selectedYear} onChange={(e) => setSelectedYear(Number(e.target.value))}>
                {year.map((y, index) => (
                  <option key={index} value={y}>{y}</option>
                ))}
              </select>
            </td>
          </tr>
          <tr>
            <td colSpan={4} align="center">
              <button   className="button button2" onClick={handleSubmit} >Submit</button>
              <button   className="button button2"   onClick={() => window.history.back()}>Back</button>
            </td>
          </tr>
        </tbody>
      </table>
      <br/><br/>
      {renderContent}
      <br/><br/>
      <br/><br/>
      <br/><br/>
      
    </div>
    
  );
}

export default Portability;
